import { ChatFixture, tokenize, StreamChunk } from './types';

/**
 * Journey 2 — deep-research.
 *
 * Streams an "Assessing..." status, then a ~150-word cited legal brief with 3
 * inline citations, then a final "pdf_ready" event pointing at a fixture URL.
 */

const briefParagraph =
  'California recognizes wrongful termination in violation of public policy under Tameny v. Atlantic ' +
  'Richfield Co., 27 Cal. 3d 167 (1980) [1]. An employee who is terminated for exercising a statutory ' +
  'right — such as filing a workers compensation claim or reporting unsafe working conditions — may ' +
  'state a tort claim for wrongful termination. The California Supreme Court reinforced this framework ' +
  'in Gantt v. Sentry Insurance, 1 Cal. 4th 1083 (1992) [2], which limits the public-policy exception ' +
  'to policies "carefully tethered" to a constitutional or statutory source. More recently, Green v. ' +
  'Ralee Engineering Co., 19 Cal. 4th 66 (1998) [3] extended the doctrine to retaliation for reporting ' +
  'federal safety violations. Demand letters in this space should establish (a) the tethering source, ' +
  '(b) the protected activity, and (c) the causal link between the activity and the adverse action.';

const citations: StreamChunk[] = [
  {
    delta: '',
    delayMs: 60,
    event: 'citation',
    data: {
      index: 1,
      title: 'Tameny v. Atlantic Richfield Co.',
      citation: '27 Cal. 3d 167 (1980)',
      url: 'https://scholar.google.com/scholar_case?case=tameny',
    },
  },
  {
    delta: '',
    delayMs: 40,
    event: 'citation',
    data: {
      index: 2,
      title: 'Gantt v. Sentry Insurance',
      citation: '1 Cal. 4th 1083 (1992)',
      url: 'https://scholar.google.com/scholar_case?case=gantt',
    },
  },
  {
    delta: '',
    delayMs: 40,
    event: 'citation',
    data: {
      index: 3,
      title: 'Green v. Ralee Engineering Co.',
      citation: '19 Cal. 4th 66 (1998)',
      url: 'https://scholar.google.com/scholar_case?case=green-ralee',
    },
  },
];

export const deepResearchFixture: ChatFixture = {
  id: 'deep-research',
  userQuery:
    'Research the current California standard for wrongful termination in violation of public policy.',
  steps: ['assessing', 'searching', 'drafting', 'citations', 'pdf-ready'],
  chunks: [
    { delta: '', delayMs: 220, event: 'thinking', data: { label: 'Assessing...' } },
    { delta: '', delayMs: 180, event: 'thinking', data: { label: 'Searching case law...' } },
    { delta: '', delayMs: 140, event: 'thinking', data: { label: 'Drafting brief...' } },
    ...tokenize(briefParagraph, 40),
    ...citations,
    {
      delta: '',
      delayMs: 200,
      event: 'pdf_ready',
      data: {
        title: 'CA Wrongful Termination — Research Brief',
        // No `url`: this is scripted demo data, and the path that used to sit
        // here pointed at a file that has never existed. Nothing renders it
        // today (MoonshotVoiceChat treats pdf_ready as a HUD event), so it
        // was harmless — but the day something DOES render it, the SPA
        // fallback would hand a viewer 28KB of HTML named as a PDF, with no
        // 404 anywhere. Add a real file under public/moonshot/pdf/ and the
        // url with it; scripts/check-static-asset-links.mjs refuses the
        // dangling shape.
        pageCount: 3,
      },
    },
  ],
};

export default deepResearchFixture;
